<template>
	<div class="flex-container scrollMessage tg-message" v-show="showStatus">
		<div class="paddingr30 borderr text-center">
			<img :src="titleImage" style="max-height: 30px;max-width: 60px;min-width: 30px">
		</div>
		<div class="flex1">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<a :href="item.clickUrl"
					   data-scp="kx.{{$index}}"
					   :data-bk="item.bk" class="swiper-slide flex-container center left" v-for="item in items">
						<div class="badge badge-red badge-reverse badge-radius marginr20" v-if="item.subTitle" v-text="item.title"></div>
						<span class="text-dark text-limit2 fs-12" v-text="item.subTitle?item.subTitle:item.title"></span>
						<img :src="item.subImageUrl" v-if="item.subImageUrl" alt="" class="pos-a right10" style="width:20px;height:20px;">
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import maple from 'maple';
import $ from 'jquery';
import _ from '_';

let swiper = maple.swiper;

export default {
	props: {
		data: {
			type: Object
			, default: {
				items: []
			}
		},
		target:{
			type:Object,
			default:{}
		}
	},
	data: function(){
		return {
			items: this.data.items
			, titleImage:''
			, showStatus: !!this.data.items.length
		};
	}
	, ready: function(){
		var that = this;
		if( this.items.length > 1 ){
			this.swiper = new swiper($(this.$el).find('.swiper-container')[0], {
				autoplay: 2000,
				loop: true,
				direction: 'vertical',
				onSlideChangeStart:function(swiper){
					var realIndex=that.items[swiper.activeIndex-1]?(swiper.activeIndex-1):0
					that.titleImage=that.items[realIndex].imageUrl
				}
			});
		}
	}
	, watch: {
		data: function(newData, oldData){
			var that = this;
			this.$set('items', newData.items);
			this.$set('showStatus', !!newData.items.length);
			this.swiper && this.swiper.destroy(false, true);
			setTimeout(function(){
				if( that.items.length > 1 ){
					that.swiper=new swiper($(that.$el).find('.swiper-container')[0], {
						autoplay:2000,
						loop:true,
						direction:'vertical',
						onSlideChangeStart:function(swiper){				
							var realIndex=that.items[swiper.activeIndex-1]?(swiper.activeIndex-1):0
							that.titleImage=that.items[realIndex].imageUrl
						}
					});
				}else if(that.items.length = 1){
					that.titleImage=_.get(that,'items[0].imageUrl')
				}
			}, 0);
		}
	}
};
</script>
<style lang="scss">
@import 'style.css';
@import 'style-theme-1.css';
</style>